import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import Button from '@material-ui/core/Button';

import { CircularProgress } from '@material-ui/core';

import PrintIcon from '@material-ui/icons/Print';

class Article extends Component {
  render() {
    const { classes, showPrice, labelPrinting, printing, printProductLabels } = this.props;

    const features = this.props.value.features
      ? <Typography className={classes.features} color="textSecondary">{this.props.value.features.join(', ')}</Typography>
      : null;

    const note = this.props.value.note
      ? <Typography className={classes.note}>{this.props.value.note}</Typography>
      : null;

    return (
      <div className={classes.root}>
        <div className={classes.articleContainer}>
          <Typography className={classes.quantity}>{this.props.value.quantity}</Typography>
          <>
            <Typography className={classes.name}>
              {this.props.value.name}
              {this.props.value.labelPrintCount ? 
              (<Typography className={classes.subtitle}>
                Gedruckt: {this.props.value.labelPrintCount || 0}
              </Typography>) : null}
            </Typography>
          </>
          {showPrice ?
            <Typography className={classes.price}>{this.props.value.price.toFixed(2).replace('.', ',')}€</Typography>
            : null}
          {labelPrinting ?  (
            <Button
              variant="outlined"              
              className={classes.button}
              disabled={printing}
              onClick={() => {                
                printProductLabels(this.props.value.entries);
              }}
            >
              {printing ?
                <CircularProgress size={25} />
                :
                <PrintIcon />
              }
            </Button >
          ) : null}
        </div>
        {features}
        {note}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: "100%",
  },
  articleContainer: {
    display: 'flex',
    flex: 1,
    width: "100%",
    justifyContent: "space-between",
  },
  quantity: {
    width: theme.article.quantityWidth,
  },
  name: {
    flex: 10,
  },
  subtitle: {
    color: '#999',
    fontSize: 14,

  },
  price: {
    flex: 1,
  },
  button: {
    mintHeight: 100
  },
  features: {
    marginLeft: theme.article.quantityWidth,
  },
  note: {
    color: theme.palette.error.dark,
    marginLeft: theme.article.quantityWidth,
  },
});

Article.propTypes = {
  value: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Article);
